import { render } from "./PromptsPanel.vue?vue&type=template&id=1878a198&scoped=true"
import script from "./PromptsPanel.vue?vue&type=script&lang=js"
export * from "./PromptsPanel.vue?vue&type=script&lang=js"

import "./PromptsPanel.vue?vue&type=style&index=0&id=1878a198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1878a198"]])

export default __exports__